<template>
    <section class="table pb70">
        <div class="box">
            <div class="table__header">
                <h1>{{ title }}: {{project.project}}</h1>
                <div class="btns">
                    <router-link class="btn" :to="{ name: 'projectList' }">
                        <i class="fal fa-backspace"></i>
                    </router-link>
                </div>
            </div>


            <div v-if="!loading" class="info-box">
                Per questo progetto l'impostazione Offline conversion è impostata a <strong>{{project.offline_conversion ? 'true' : 'false'}}</strong>
            </div>

            <div class="table__form">

                <!-- Loader -->
                <div v-if="loading" class="loading-box">
                    <i class="fal fa-sync-alt fa-spin"></i>
                    <span> Caricamento...</span>
                </div>

                <div v-if="noBookings" class="no-bookings">
                    Non ci sono canali da gestire.
                </div>

                <!-- Contenuto -->
                <div
                    v-else
                    class="multiple"
                    v-for="(booking, bookingIndex) in bookings"
                    :key="'booking-' + (booking.id !== undefined ? booking.id : bookingIndex) + '-' + bookingIndex"
                >
                    <h2>{{ booking.name ? booking.name : booking.idBlastbook }}</h2>



                    <div class="form_inline" style="margin-bottom: 5px"  v-for="channel in channels" :key="channel">
                        <div class="w-25 mr-2">
                            <strong class="mb-0">{{ channel }}</strong>
                        </div>

                        <div
                            class="checkbox-wrapper-6"
                            style="margin-right: 10px; display: inline-block;"
                        >
                            <input
                                class="tgl tgl-light"
                                type="checkbox"
                                :id="'booking-' + bookingIndex + '-' + channel"
                                :checked="booking.services[channel]"
                                @change="toggleService(booking, channel, $event.target.checked)"
                            />
                            <label class="tgl-btn" :for="'booking-' + bookingIndex + '-' + channel"></label>
                        </div>
                    </div>



                </div>

                <div class="bcm_action" style="display: flex; justify-content: space-between;">
                    <div>
                        <div><strong>Created</strong>: {{ project.requestLogCreate }}</div>
                        <div><strong>Updated</strong>: {{ project.requestLogUpade }}</div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            title: "Channels",
            channels: ["GoogleAds", "BingAds", "GoogleHotelAds", "Trivago", "TripAdvisor"],
            project: {},
            bookings: [],
            loading: false,
            noBookings: false
        };
    },

    methods: {
        async loadProject() {
            this.loading = true;
            try {
                const { data } = await axios.get(
                    `${process.env.VUE_APP_API_URL}channels/${this.$route.params.id}`
                );
                this.project = data.result || {};
                this.bookings = data.data.ProjectBooking || [];
                this.noBookings = this.bookings.length === 0;
            } catch (error) {
                console.error("Errore caricamento progetto:", error);
            } finally {
                this.loading = false;
            }
        },

        async toggleService(booking, channel, value) {
            try {
                const payload = {
                    blastbookId: booking.idBlastbook,
                    isActive: value,
                    servizio: channel
                };

                await axios.put(`${process.env.VUE_APP_API_URL}channels/update`, payload);
                booking.services[channel] = value;

            } catch (error) {
                console.error("Errore aggiornamento servizio:", error);
            } finally {

                this.$store.state.messages.push({
                    id: Math.floor(Math.random() * 100000),
                    msg: {
                        success: true,
                        message: 'Salvato con successo'
                    }
                });

            }
        }
    },

    watch: {
        $route() {
            this.loadProject();
        }
    },

    created() {
        this.loadProject();
    }
};
</script>

<style scoped>
.loading-box, .no-bookings {
    padding: 30px;
    text-align: center;
    font-size: 1rem;
    color: #333;
    margin-bottom: 0!important;
}

.loading-box i {
    font-size: 2rem;
    margin-bottom: 10px;
    display: block;
}
</style>
